import { render } from "./OffCanvas copy.vue?vue&type=template&id=d82f1c66"
import script from "./OffCanvas copy.vue?vue&type=script&lang=js"
export * from "./OffCanvas copy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../DIARC/texnoelm/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__